import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
// import { isBOSC } from '../../../utils/share';
import { useStyles } from '../styles/quaterGoalStyles';

const QuarterGoal = () => {
  const classes = useStyles();
  const goalTitle = useSelector((state) => state?.login?.user?.quarterGoalTitle || null);
  
  // if (!isBOSC()) return null;

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2" gutterBottom className={classes.subtitle}>
        The Goal Of This Quarter
      </Typography>
      <div className={classes.marqueeContainer}>
        <b className={classes.marqueeContent}>{goalTitle}</b>
      </div>
    </div>
  );
};

export default QuarterGoal;
